import getUserMailboxInfo from 'owa-client-ids/lib/utils/getUserMailboxInfo';
import { logUsage as logUsageWithMailbox } from 'owa-analytics';
import type { CustomData, DatapointOptions } from 'owa-analytics-types';

export function logUsage<TKeys extends string = string>(
    eventName: string,
    customData?: CustomData<TKeys>,
    options?: DatapointOptions,
    shouldYield?: boolean
): Promise<void> {
    return logUsageWithMailbox(eventName, getUserMailboxInfo(), customData, options, shouldYield);
}
